import apiClient from '@/api/client'
import type { ApiResponse } from '@/types/api'
import type { NotificationFeed } from '../types'

export const notificationsApi = {
  fetchAll: () => apiClient.get<ApiResponse<NotificationFeed>>('/me/notifications'),

  markRead: (id: string) => apiClient.post(`/me/notifications/${id}/read`),

  markAllRead: () => apiClient.post('/me/notifications/read-all'),
}
